import { camelizeKeys } from 'humps';

import {
  Endpoints,
  GetWalkerStripeLoginLinkErrors,
} from '../../../constants';
import { wagApi } from '../../../types/wagapi';
import { tryCatch } from '../../../utils';
import {
  buildApiErrorPipeline,
  mapErrorByType,
  mapErrorToApiSlice,
  ApiErrorV4,
} from '../../../utils/buildApiErrorPipeline';
import { createErrorForV4 } from '../../../utils/buildApiErrorPipeline/createErrorForV4/createErrorForV4';
import { walkerApiSlice } from '../../apiSlice';

export const walkerApi = walkerApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWalkerStripeLoginLink: builder.query<
      wagApi.V4.GetWalkerStripeLoginLinkResponse,
      wagApi.V4.GetWalkerStripeLoginLinkPayload
    >({
      queryFn: async (params, _api, _extraOptions, query) => {
        const url = Endpoints.V4.GetWalkerStripeLoginLink;

        const adjustedArgs = {
          url,
          method: 'GET',
          params,
        };

        const [response] = await tryCatch(() => query(adjustedArgs));

        /**
         * V4 endpoints return a `success` of false
         * if the request is invalid
         */
        if (response.error || !response.data.success) {
          const error = createErrorForV4({
            type: '_user.invalid_request',
            message: '',
            name: '',
            version: 4,
            success: false,
          } as ApiErrorV4);

          return buildApiErrorPipeline(error)
            .pipe(
              mapErrorByType(GetWalkerStripeLoginLinkErrors.V4),
              mapErrorToApiSlice,
            );
        }

        return {
          ...response,
          data: camelizeKeys(response.data),
        };
      },
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetWalkerStripeLoginLinkQuery,
  useLazyGetWalkerStripeLoginLinkQuery,
} = walkerApi;
